module.exports = __webpack_public_path__ + "assets/img/7.024f57c7.png";